import { useNavigate, useParams } from "react-router-dom";
import { IncidentStage } from "./incidentslist";
import { useGetIncident, useGetIncidentDefintions } from "../../../../new/query";
import { useMemo, useState } from "react";
import styles from '../../../../styles/incidents.module.css';
import { Button, Col, Row } from "react-bootstrap";
import IncidentInitialNew from "./incidentinitialnew";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import IncidentFollowupNew from "./incidentfollowupnew";
import IncidentAssignStaffNew from "./incidentassignstaffnew";
import IncidentResponseToFollowupNew from "./incidentresponsetofollowupnew";
import IncidentErrorAlert from "./incidenterroralert";

const steps = [
    {key: 'initial', label: 'Initial Incident Report',stage: IncidentStage.Initial},
    {key: 'followup',label: 'Followup',stage: IncidentStage.Followup},
    {key: 'followupstaff',label: 'Followup Staff Assignments',stage: IncidentStage.FollowupStaff},
    {key: 'responsetofollowup',label: 'Response To Followup',stage: IncidentStage.ResponseToFollowup}
]

const IncidentWizardNew = () => {
    const {id,medicaidid} = useParams();
    const isDraft = !id;
    const navigate = useNavigate();
    const incidentQuery = useGetIncident(id);
    const definitionsQuery = useGetIncidentDefintions();
    const incident = incidentQuery.data;
    const definitions = definitionsQuery.data;
    const[activeStep,setActiveStep] = useState(0);

    const maxStage = incident?.stage ?? IncidentStage.None;

    const allowedStepIndex = useMemo(() => {
        if(isDraft) return 0;
        const lastCompletedIdx = Math.max(0,steps.findIndex(s => s.stage === maxStage));
        return Math.min(lastCompletedIdx + 1,steps.length - 1);
    },[isDraft,maxStage])

    const canNavigateTo = (index) => index <= allowedStepIndex;
    const goNext = () => {
        setActiveStep(s => Math.min(steps.length - 1,s + 1));
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    };

    const safeMedicaidId = encodeURIComponent(medicaidid)

    const goList = () => navigate(`/Client/Client/${safeMedicaidId}/incidents`);

    const currentStep = steps[activeStep];

    if(definitionsQuery.isLoading || (!isDraft && incidentQuery.isLoading)) {
        return <div>loading...</div>;
    }

    if(definitionsQuery.isError) {
        return (
            <Row>
                <Col xs={12}>
                    <IncidentErrorAlert
                        error={definitionsQuery.error}
                        fallbackMessage="The incident definitions could not be loaded."
                    />
                </Col>
            </Row>
        );
    }

    if(!isDraft && incidentQuery.isError) {
        return (
            <Row>
                <Col xs={12}>
                    <IncidentErrorAlert
                        error={incidentQuery.error}
                        fallbackMessage="The incident could not be loaded."
                    />
                </Col>
            </Row>
        );
    }

    if(isDraft){
        return(
            <Row>
                <Col xs={12}>
                <div className="clientCard">
                    <div className={styles.incidentWizardContainer}>
                        <Box sx={{ width: '100%' }}>
                            <Stepper activeStep={0} alternativeLabel nonLinear>
                                {steps.map((s, idx) => (
                                <Step key={s.key}>
                                    <StepButton color="inherit" disabled={idx !== 0}>
                                    {s.label}
                                    </StepButton>
                                </Step>
                                ))}
                            </Stepper>
                        </Box>
                        <div className={`${styles.incidentWizardForm} mt-4`}>
                            <h4 className="text-center">{currentStep.label}</h4>
                            <IncidentInitialNew key='init' incident={null} defintions={definitions}  medicaidid={medicaidid} onCreated={(data) => {navigate(`/Client/Client/${safeMedicaidId}/incidents/${data.id}`,{replace: true}); goNext();}}/>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <Button variant="link" style={{textDecoration: 'none'}} onClick={goList}>
                            Return to Incidents
                        </Button>
                    </div>
                </div>
                </Col>
            </Row>
        )
    }

    if(!incident) return <div>loading...</div>

    return(
        <Row>
            <Col xs={12}>
                <div className="clientCard">
                    <div className={styles.incidentWizardContainer}>
                        <Box sx={{ width: '100%' }}>
                            <Stepper activeStep={activeStep} alternativeLabel nonLinear>
                                {steps.map((s, idx) => (
                                <Step key={s.key} completed={(incident.stage ?? 0) >= s.stage}>
                                    <StepButton color="inherit" onClick={() => canNavigateTo(idx) && setActiveStep(idx)} disabled={!canNavigateTo(idx)}>
                                    {s.label}
                                    </StepButton>
                                </Step>
                                ))}
                            </Stepper>
                        </Box>
                        <div className={`${styles.incidentWizardForm} mt-4`}>
                            <h4 className="text-center">{currentStep.label}</h4>
                            {activeStep === 0 && <IncidentInitialNew key='initedit' incident={
                                (() => {
                                    const {stage,followup,followupStaff,responseToFollowup,...rest} = incident;

                                    return(rest);
                                })()
                            } defintions={definitions} medicaidid={medicaidid}/>}
                            {activeStep === 1 && <IncidentFollowupNew values={incident.followup} incidentid={incident.id} medicaidid={medicaidid}  onCreated={goNext}/>}
                            {activeStep === 2 && <IncidentAssignStaffNew defintions={definitions} values={incident.followupStaff} medicaidid={medicaidid}  incidentid={incident.id} onCreated={goNext} /> }
                            {activeStep === 3 && <IncidentResponseToFollowupNew values={incident.responseToFollowup} definitions={definitions} medicaidid={medicaidid}  incidentid={incident.id} staffAssignments={incident.followupStaff} /> }
                        </div>
                        <div className="d-flex justify-content-center">
                            <Button variant="link" style={{textDecoration: 'none'}} onClick={goList}>
                                Return to Incidents
                            </Button>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default IncidentWizardNew;
